const DEVELOPMENT_MODE = 'development';

const isDevelopmentBuild = (): boolean => import.meta.env.MODE === DEVELOPMENT_MODE;

export const shouldShowDevTools = (): boolean => isDevelopmentBuild();

export const shouldShowCubeQueryRunner = (): boolean => isDevelopmentBuild();

export const shouldShowFeatureToggles = (): boolean => isDevelopmentBuild();
